
import { useEffect, useState } from "react";

interface BackgroundImageProps {
  backgroundImage: string;
  isLoadingImage: boolean;
}

export const BackgroundImage = ({ backgroundImage, isLoadingImage }: BackgroundImageProps) => {
  return (
    <div className="fixed inset-0 z-0">
      {isLoadingImage ? (
        <div className="absolute inset-0 bg-black flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
        </div>
      ) : (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url('${backgroundImage}')` }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-purple-900/40 via-black/60 to-black"></div>
        </div>
      )}
    </div>
  );
};
